import {Button, Paper} from '@mui/material';

import './RoundButton.scss';

function RoundButton({className, buttonIcon, handleOnClick}) {
  const buttonClassName = `round-button ${className ? className : ''}`;

  if (!buttonIcon) return null;
  return (
    <Paper className={buttonClassName}>
      <Button
        className="map-filter-button"
        onClick={handleOnClick}
      >
        {buttonIcon} 
      </Button>
    </Paper>
  );
}

export default RoundButton;
